import React, {useEffect, useState} from 'react'

import {useNavigation} from 'react-navi'
import {useAppState} from '../../../state'
import {useTranslation} from 'react-i18next'

import {MainLayoutWithoutStretch, MainContent, RightSidebar} from '../../Layout/Layout'
import {HeaderTitle, HeaderRow, HeaderActions} from '../../Molecules/ViewComponents/ViewHeader'
import {Baseline, InvisibleContainer} from '../../Layout/Grid'
import ChainList from './ChainList'
import EditNewsTicker from './EditNewsTicker'
import {getSites} from '../../../config/utils'
import {Helmet} from 'react-navi-helmet-async'
import SearchRow from '../../Molecules/SearchRow'
import styled from 'styled-components'

/**
 * TODO: handle loading and error states
 */
const AdminView = () => {
  const {t} = useTranslation('admin')
  const nav = useNavigation()
  const {state, effects, actions} = useAppState()
  const handleEdit = (id: string) => {
    nav.navigate('edit/chain/' + id)
  }
  useEffect(() => {
    actions.getChains()
  }, [effects])

  const onSelectChain = async (id: string) => {
    const sites = getSites(state.chainsById[id as keyof typeof state.chainsById])

    if (sites.length > 0) {
      localStorage.setItem('selectedChainId', id)
      window.location.reload()
    } else {
    }
  }
  const onMessagesSelected = () => {
    nav.navigate('admin/messages')
  }
  const createNewChain = async () => {
    const chainId = await actions.createOrganization()
    nav.navigate('edit/chain/' + chainId)
  }
  const downloadUserList = async () => {
    await actions.downloadUserList()
  }
  const [searchQuery, setSearchQuery] = useState('')
  let filteredChains = state.chains
  if (searchQuery !== '') {
    filteredChains = state.chains.filter(chain => chain.name.toLowerCase().includes(searchQuery.toLowerCase()))
  }
  return (
    <MainLayoutWithoutStretch>
      <Helmet title={t('common:routes.admin', 'Admin')} />
      <MainContent variant="white" data-cy="chefstein-superuser-home-page">
        <HeaderRow description={t('admin:messages.viewDescription', 'Select which chain you want to view.')}>
          <HeaderTitle>{t('admin:labels.adminTitle', 'CGI Chefstein')}</HeaderTitle>
          <HeaderActions
            onAdd={createNewChain}
            onPrint={() => downloadUserList()}
            onMessage={() => onMessagesSelected()}
          />
        </HeaderRow>
        <SearchRow
          placeholderText={t('home:labels.searchChain', 'Search customers')}
          setSearchQuery={setSearchQuery}
          backgroundColor={''}
        />
        {filteredChains !== undefined && filteredChains.length !== 0 && (
          <Baseline>
            <ChainList onSelectChain={onSelectChain} chains={filteredChains} onConfigure={handleEdit} />
          </Baseline>
        )}
        {
          <NoResultMessageView>
            {filteredChains.length === 0 && <Baseline>{t('admin:messages.noResults', 'No results')}</Baseline>}
          </NoResultMessageView>
        }
      </MainContent>
      <RightSidebar>
        <InvisibleContainer style={{marginTop: '11rem'}}>
          <EditNewsTicker />
        </InvisibleContainer>
      </RightSidebar>
    </MainLayoutWithoutStretch>
  )
}
const NoResultMessageView = styled.div`
  margin: 1rem 0 0 2rem;
`

export default () => {
  const {state} = useAppState()
  return !!state.me && !!state.currentUser ? <AdminView /> : null
}
